module.exports = __webpack_public_path__ + "img/bg_right.2b23ad8c.png";